import BaseTracker from './base-tracker';

export default class ResumeTracker extends BaseTracker {
  start() {
    this._player.addEventListener('playing', this._onPlaying);
  }

  _onPlaying = () => {
    this.track();
  };

  stop() {
    this._player.removeEventListener('playing', this._onPlaying);
  }
}
